import { Reveal } from '@/components/Reveal';
import { Section } from '@/components/Section';
import { process } from '@/content/site';
import styles from './Process.module.css';

export function Process() {
  return (
    <Section
      id="process"
      tone="raised"
      eyebrow="process"
      title="A short, honest path from problem to production"
      lead="No discovery theatre and no six-month silences. Every phase ends with something you can review, keep and act on."
    >
      <ol className={styles.list}>
        {process.map((step, index) => (
          <Reveal as="li" key={step.phase} className={styles.item} delay={index * 70}>
            <span className={styles.marker} aria-hidden="true">
              {step.phase}
            </span>

            <div className={styles.body}>
              <div className={styles.head}>
                <h3 className={styles.title}>{step.title}</h3>
                <span className={styles.duration}>{step.duration}</span>
              </div>
              <p className={styles.description}>{step.description}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </Section>
  );
}
